import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { withRouter } from 'kts-platform-frame/routes';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Field } from 'kts-scaffold-framework/utils/doc';
import Info from './UI.Info';
import Footer from './UI.Detail.Footer';
import { Modal, Spin, Button, Row, Col, Form, Badge, Tag, Table, Card, message } from 'antd';
import {InvalidBtn, MatchBtn, FinishBtn,DetailBtn, } from './UI.Detail.Btn';
import { inputSettlement } from 'src/api';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}


/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))


class Detail extends UIBasic<IProps, ModulesState> {
    public columns = [
        {
            title: '序号',
            dataIndex: 'index',
            width: 80,
            render: (text, record, index) => {
                return <div>{index + 1}</div>;
            }
        },
        {
            title: '税务编码',
            dataIndex: 'taxCode',
            width: 120,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '货物（劳务）名称',
            dataIndex: 'name',
            width: 280,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '规格型号',
            dataIndex: 'specification',
            width: 150,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '数量',
            dataIndex: 'quantity',
            width: 80,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '单价',
            dataIndex: 'unitPrice',
            width: 140,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '无税金额',
            dataIndex: 'amountWithoutTax',
            width: 140,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '税率',
            dataIndex: 'taxPercent',
            width: 140,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '税额',
            dataIndex: 'amountTax',
            width: 140,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '价税合计',
            dataIndex: 'amount',
            width: 140,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount ()  {
        ModulesAction.updateDetail(this.props.match.params.id);
    }
    

    render() {
        const {loadingUrls} = this.props;
        const FormItem = Form.Item;
        const {detailInfo} = this.modulesState;
        const extraButtons = (
            <div>
                <InvalidBtn detailInfo={detailInfo} toInvalid={this.toInvalid}/>
                <FinishBtn detailInfo={detailInfo} />
                <MatchBtn detailInfo={detailInfo}  />
                <DetailBtn detailInfo={detailInfo} />
                <Button icon="sync" className="mr10" onClick={()=>{this.refresh();}}>刷新 </Button>
                <Button icon="left" onClick={()=>this.goBack()}>返回 </Button>
            </div>
        );
        return (
            <div className={css.right}>
                <Card title="结算单详情" extra={extraButtons}>
                    <Info />
                    <Spin spinning={loadingUrls.size>0} >
                        <Table 
                            scroll={{ x: 1000 }}
                            columns={this.columns}
                            dataSource={this.modulesState.detailList}
                            pagination={false}
                            rowKey={'detailedId'}
                        />
                    </Spin>
                    <Footer />
                </Card>
                
            </div>
        );
    }
    private goBack () {
        history.go(-1);
    }
    private refresh () {
        ModulesAction.updateDetail(this.props.match.params.id);
    }
    private toInvalid = () => {
        Modal.confirm({
            title: '提示',
            content: '确认作废此结算单吗?',
            onOk: async() => {
                const result = await inputSettlement.invalid(this,[this.props.match.params.id]);
                if (!result.er) {
                    message.info('操作成功！');
                }
                ModulesAction.updateDetail(this.props.match.params.id);
            }
        });

    }
    // private getSuccessLength = (arr) => {
    //     let num = 0;
    //     for (let item of arr) {
    //         if (Object.entries(item)[0][1] === 'true') {
    //             num += 1;
    //         }
    //     }
    //     return num;
    // }
    // private getFailedLength = (arr) => {
    //     let num = 0
    //     for (let item of arr) {
    //         if (Object.entries(item)[1] !== 'true') {
    //             num += 1;
    //         }
    //     }
    //     return num;
    // }
}
export default Detail;



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Detail.tsx